<div class="container-cuentas-voluntarias">
  <div class="wrapper"> 
    <div class="grid-container">
      <ion-text class="title ion-text-start">Cuentas Voluntarias</ion-text>
      <ion-grid class="grid">
          <ion-row class="grid-header">
              <ion-col class="left-header-col" size="2"> 
                  <ion-text class="grid-header-text">Elige</ion-text></ion-col>
              <ion-col class="mid-header-col" size-xs="4" size-sm="5" size-md="4" size-xl="5">
                  <ion-text class="grid-header-text">Cuenta</ion-text></ion-col>
              <ion-col class="right-header-col">
                  <ion-text class="grid-header-text">Saldo a congelar</ion-text></ion-col>
          </ion-row>
          <ion-row class="grid-content-ccv" id="row-ccv" *ngIf="ccvAmount > 0">
              <ion-col class="left-col" size="2">
                <ion-checkbox (ionChange)="ccvCheckboxClick($event)"></ion-checkbox></ion-col>
              
              <ion-col class="mid-col" size-xs="4" size-sm="5" size-md="4" size-xl="5">
                <ion-text class="account-type-text">APV - Ahorro Previsional Voluntario <br></ion-text>
                <ion-text class="account-amount-text">
                    Saldo: {{ numberToChileanCurrency(ccvAmount) }}</ion-text>
              </ion-col>
              
              <ion-col class="right-col" size-xs="6" size-sm="5" size-md="6" size-xl="5" [formGroup]="ccvFormGroup">
                <app-outline-input #ccvOutlineInput
                  inputmode="numeric"
                  formControlName="ccvPercentage"
                  label="Ingresa un porcentaje"
                  [maxlength]="3"
                  (ngModelChange)="ccvSelectedAmountChange()"
                >
                </app-outline-input>
                <ion-text class="selected-amount-text"> 
                 {{getSelectedCCVAmmount()}}</ion-text>
              </ion-col>
          </ion-row>
          <ion-row class="grid-content-cav" id="row-cav" *ngIf="cavAmount > 0">
              <ion-col class="left-col" size="2">
                  <ion-checkbox (ionChange)="cavCheckboxClick($event)"></ion-checkbox></ion-col>
              <ion-col class="mid-col" size-xs="4" size-sm="5" size-md="4" size-xl="5">
                  <ion-text class="account-type-text">Cuenta 2 - Ahorro Voluntario<br></ion-text>
                  <ion-text class="account-amount-text">
                      Saldo: {{ numberToChileanCurrency(cavAmount) }}</ion-text>
              </ion-col>
              <ion-col class="right-col" size-xs="6" size-sm="5" size-md="6" size-xl="5"[formGroup]="cavFormGroup">
                <app-outline-input #cavOutlineInput
                  inputmode="numeric"
                  formControlName="cavPercentage"
                  label="Ingresa un porcentaje"
                  [maxlength]="3"
                  (ngModelChange)="cavSelectedAmountChange()"
                >
                </app-outline-input>
                <ion-text class="selected-amount-text">
                  {{getSelectedCAVAmmount()}}
                </ion-text>
              </ion-col>
          </ion-row>
          <ion-row class="grid-content-total">
              <ion-col  class="left-col" size-xs="6" size-sm="7" size-md="6" size-xl="7">
                  <ion-text class="selected-amount-text">Total a congelar</ion-text></ion-col>
              <ion-col class="right-col" size-xs="6" size-sm="5" size-md="6" size-xl="5">
                  <ion-text class="selected-amount-text">{{ numberToChileanCurrency(selectedAmount) }}</ion-text>
              </ion-col>
          </ion-row>
      </ion-grid>
    </div>
  </div>
</div>